import React, { useState } from "react";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { TableColumn } from "utils/types";
import TableToolbar from "./TableToolbar";

type ItemsTableProps<T> = {
  columns: TableColumn<T>[];
  data: T[];
  searchFields?: (keyof T)[];
  toolbarBtnClassName?: string;
  toolbarBtnLabel?: string;
  onToolbarBtnClick?: () => void;
  isLoading?: boolean;
  showToolbar?: boolean;
};
const ItemsTable = <T,>({
  columns,
  data,
  onToolbarBtnClick = () => {},
  searchFields,
  toolbarBtnClassName,
  toolbarBtnLabel,
  isLoading,
  showToolbar = true,
}: ItemsTableProps<T>) => {
  const [filterItems, setFilterItems] = useState<T[]>([]);
  return (
    <>
      {showToolbar && <TableToolbar
        searchData={data}
        onSearch={setFilterItems}
        onClickBtn={onToolbarBtnClick}
        searchFields={searchFields ?? Object.keys(data[0] as object) as (keyof T)[]}
        classNameBtn={toolbarBtnClassName}
        labelBtn={toolbarBtnLabel}
      />}
      <DataTable
        value={showToolbar ? filterItems : data}
        stripedRows
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 25, 50]}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
        loading={isLoading}
        size="small"
        sortField={columns[0]?.field as string}
        sortOrder={1}
      >
        {columns.map(col => (
          <Column
            key={col.header}
            {...col}
          />
        ))}
      </DataTable>
    </>
  );
};

export default ItemsTable;
